import React from "react";
import { useLocationContext } from "../contexts/LocationContext";
import Icon from "./AppIcon";

const LocationSelectorModal = () => {
  const { locations, setCurrentLocation, needsLocationSelection } =
    useLocationContext();

  if (!needsLocationSelection) return null;

  return (
    <div className="fixed inset-0 bg-black/40 z-[1200] flex items-center justify-center">
      <div className="bg-card rounded-lg shadow-xl w-full max-w-md p-8">
        <div className="mb-6 text-center">
          <Icon name="MapPin" size={32} className="mx-auto mb-2 text-primary" />
          <h2 className="text-xl font-semibold mb-2">Select a Location</h2>
          <p className="text-muted-foreground">
            Please select a location to view location-specific information.
          </p>
        </div>
        <div className="space-y-3">
          {locations.map((loc) => (
            <button
              key={loc.id}
              className="w-full btn btn-outline flex items-center gap-2"
              onClick={() => setCurrentLocation(loc)}
            >
              <Icon name="Building2" size={18} />
              <span>{loc.name}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LocationSelectorModal;
